const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const CanvasView = require("./Canvas");
const CanvasImage = require("../util/CanvasImage");
const {getBaseInstance} = require("../util/HOCUtil");

const getNow = () =>
	global.performance ? global.performance.now() : Date.now();

module.exports = createReactClass({
	displayName: "AnimatingCanvas",

	propTypes: {
		// Most propTypes are sync'd with those of Canvas.jsx.
		canvasEl: PT.instanceOf(global.HTMLCanvasElement),
		width: PT.number,
		height: PT.number,
		padding: PT.object,
		className: PT.string,
		canvasType: PT.string,
		draw: PT.func.isRequired,
		noContextMenu: PT.bool,
		noPointerEvents: PT.bool,
		isMeasured: PT.bool,
	},

	stopAnimations: function() {
		// Each animation records the initial value of this counter and stops if
		// its recorded value is less than the current one.
		this.stopGeneration = (this.stopGeneration || 0) + 1;
	},

	componentWillUnmount: function() {
		this.stopAnimations();
	},

	draw: function(context, options) {
		this.props.draw(context, options);
	},

	render: function() {
		const canvasProps = _.pick(this.props, [
			"canvasEl",
			"width",
			"height",
			"className",
			"padding",
			"canvasType",
			"noContextMenu",
			"noPointerEvents",
			"isMeasured",
		]);
		canvasProps.draw = this.draw;
		return (
			<CanvasView
				{...canvasProps}
				ref={ref => (this.canvasComp = getBaseInstance(ref))}
			/>
		);
	},

	// Methods for external use.

	getCanvasEl: function() {
		return this.canvasComp && this.canvasComp.getCanvasEl();
	},

	getContext: function() {
		return this.canvasComp && this.canvasComp.getContext();
	},

	getCanvasSize: function() {
		return this.canvasComp && this.canvasComp.getCanvasSize();
	},

	animateDraw: function(data) {
		const context = this.getContext();
		let start = getNow();
		const myStopGeneration = this.stopGeneration || 0;

		const loop = () => {
			if (this.stopGeneration > myStopGeneration) {
				return;
			}
			const now = getNow();
			const t = (now - start) / data.duration;
			let stop = false;

			const drawWithLoading = inputT => {
				CanvasImage.withLoading(
					context,
					() => {
						data.draw(context, inputT);
					},
					() => {}
				);
			};

			if (t <= 1) {
				// Animation is ongoing
				drawWithLoading(t);
			} else {
				// Animation is past the end time
				drawWithLoading(1);
				if (data.repeat) {
					start += data.duration;
				} else {
					stop = true;
					data.onFinish && data.onFinish();
				}
			}
			if (!stop) {
				window.requestAnimationFrame(loop);
			}
		};
		window.requestAnimationFrame(loop);
	},
});
